module.exports = __webpack_public_path__ + "img/2-3.96ab6d52.svg";